import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const PinterestCircle24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      className={cn(
        chroma === 'default' && s.pinterestFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M15.84 1.44c7.947 0 14.4 6.453 14.4 14.4s-6.453 14.4-14.4 14.4-14.4-6.453-14.4-14.4 6.453-14.4 14.4-14.4zm-3.117 8.555c-3.415 2.244-2.65 5.716-2.65 5.716.37 2.215 1.807 2.576 1.807 2.576.282.09.375-.21.375-.21l.23-.938c.027-.119-.082-.244-.082-.244l-.192-.237c-.514-.761-.48-1.715-.48-1.715.13-2.5 1.636-3.533 2.386-3.917.75-.378 3.03-.976 4.685.505 1.655 1.482.778 4.641.778 4.641-.329 1.363-1.143 2.195-1.143 2.195-1.02.964-1.987.525-1.987.525-1.115-.486-.87-1.59-.87-1.59l.093-.384.204-.736s.558-1.52.505-2.378c-.053-.855-.644-1.444-1.655-1.156-1.01.288-1.208 1.735-1.208 1.735-.164 1.229.127 1.824.248 2.016l-.013.01-1.06 4.628c-.263 1.164-.263 1.83-.24 2.518.02.688.132 1.38.132 1.38.1.147.217 0 .217 0 1.23-1.62 1.528-2.746 1.528-2.746l.688-2.772c.403.672.994.887.994.887 2.185.963 4.081-.868 4.081-.868s2.16-1.753 1.881-5.363c-.273-3.61-3.368-4.635-3.368-4.635-3.393-1.244-5.884.557-5.884.557z"
      fillRule="evenodd"
    />
  </svg>
);

export default PinterestCircle24;
